import { Macros } from '@ModelViews/LibraryStructs';
import IconRest from "./Images/rest.png";
import IconJs from "./Images/js.png";
import IconMySQL from "./Images/mysql.png";
import IconInfluxDB from "./Images/InfluxDB.png";
import IconFlux from "./Images/flux.svg";
// --------------------------------------------------------------------------------------------
export function GetGemTypeIcon(type: Macros.MacroScriptType) {
    switch (type) {
        case Macros.MacroScriptType.Javascript: return IconJs;
        case Macros.MacroScriptType.MySQL: return IconMySQL;
        case Macros.MacroScriptType.Influx: return IconInfluxDB;
        case Macros.MacroScriptType.Flux: return IconFlux;
        case Macros.MacroScriptType.RestAPI: return IconRest;
        default: return "";
    }
}
// --------------------------------------------------------------------------------------------